import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { LoadingOutlined, PlusSquareOutlined } from "@ant-design/icons";
import "swiper/css";
import "swiper/css/pagination";
import { Button } from "antd";
import ProfessionsAndSkillsSwiper from "./professionsAndSkillsSwiper";
import { CustomModal } from "../../../../components/CustomModal";
import { Pagination } from "swiper/modules";
import ProfessionAndSkillModal from "../modal/ProfessionAndSkillModal";
import { useContext } from "react";
import FileKeysContext from "../../../../context/fileKeysContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createProfessionsAndSkills } from "../../../../service/api";
import ProfessionsAndSkillsContext from "../../../../context/professionsAndSkillsContext";
import UploadingProcessContext from "../../../../context/uploadingProcessContext";

function ProfessionsAndSkills({ professionsAndSkills, psLoading }) {
  const [openModal, setOpenModal] = useState(false);
  let w = document.documentElement.clientWidth || window.innerWidth;
  const [modalSize, setModalSize] = useState("");
  const [loading,setLoading] = useState()
  
  useEffect(() => {
    if (w > 640) {
      setModalSize("52vw");
    }
    if (w <= 640) {
      setModalSize("100vw");
    }
  }, [w]);
  const { multipleImagesKeys, multipleVideosKeys, resetFileKeysContext } =
    useContext(FileKeysContext);

  const { title, description, resetProfessionsAndSkillsContext } = useContext(
    ProfessionsAndSkillsContext
  );
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext)

  const queryCilent = useQueryClient();

  const mutation = useMutation(createProfessionsAndSkills, {
    onSuccess: () => {
      setOpenModal(false);
      setLoading(false)
      return queryCilent.invalidateQueries({
        queryKey: ["professionsAndSkills"],
      });
      
    },
    onMutate:()=>{
      setLoading(true)
    },
  });

  const onOk = () => {
    if (title === '' || description === '' || multipleImagesKeys.length === 0 & multipleVideosKeys.length === 0) {
      
    } else {
    // new mode
    mutation.mutate({
      title: title,
      description: description,
      files: [...multipleImagesKeys, ...multipleVideosKeys],
    });
    }
  };

  const addNew = () => {
    resetFileKeysContext();
    resetProfessionsAndSkillsContext();
    resetUploadingProcessContext();
    setOpenModal(true);
  };

  return (
    <div className="flex flex-col gap-5  bg-white max-lg:h-fit h-[480px] p-4 rounded-xl">
      {/* title */}
      <div className="text-right font-body text-[#005AC8] px-4 text-2xl font-bold">
        <h2>مهارت و حرفه</h2>
      </div>
<div>
  <h2 className="font-body text-base ">برای معرفی بیشتر خود میتوانید مهارت‌ها و حرفه‌های خود را در این بخش با استفاده از دکمه "افزودن جدید" ثبت نمائید.</h2>
</div>
      {/* swiper */}
      <div className=" max-lg:h-fit h-[380px]  ">
        <Swiper
          dir="rtl"
          modules={[Pagination]}
          setWrapperSize="100vw"
          pagination={{
            dynamicBullets: true,
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              );
            },
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.1,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 1.1,
              spaceBetween: 8,
            },
            640: {
              slidesPerView: 1.7,
              spaceBetween: 20,
            },
            1600: {
              slidesPerView: 1.7,
              spaceBetween: 16,
            },
          }}
          style={{ paddingBottom: "2.5rem" }}
        >
          {professionsAndSkills && professionsAndSkills.length === 0 ? (
            <h2 className=" animate-pulse font-body font-semibold text-xl text-[#404848] mt-32">
              شما هنوز مهارت و حرفه ای اضافه نکرده اید
            </h2>
          ) : ( psLoading === true ? <div dir="rtl" className="text-blue-400 text-2xl mt-24 h-full font-body ">درحال بارگذاری  <span ><LoadingOutlined/></span></div>:
            professionsAndSkills?.map((professionAndSkill, i) => (
              <SwiperSlide  className="w-1/2" key={i}>
                {
                  <ProfessionsAndSkillsSwiper
                    professionAndSkill={professionAndSkill}
                  />
                }
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>

      {/* add new button */}
      <div className="text-left px-4 ">
        <Button
          onClick={addNew}
          className="bg-gradient-to-r from-blue-800 to-sky-600 text-white"
          icon={<PlusSquareOutlined />}
        >
          افزودن جدید
        </Button>
      </div>
      {openModal && (
        <CustomModal
          size={modalSize}
          loading={loading}
          visible={openModal}
          handleCancel={() => setOpenModal(false)}
          onOk={onOk}
        >
          <ProfessionAndSkillModal />
        </CustomModal>
      )}
    </div>
  );
}

export default ProfessionsAndSkills;
